export default __webpack_public_path__ + "static/media/debate_24.80a16df4.JPG";